var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcludeAudienceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.66732C11.25 4.82565 9.75833 3.33398 7.91667 3.33398C6.075 3.33398 4.58333 4.82565 4.58333 6.66732C4.58333 8.50898 6.075 10.0007 7.91667 10.0007C9.75833 10.0007 11.25 8.50898 11.25 6.66732ZM1.25 15.0007V15.834C1.25 16.2923 1.625 16.6673 2.08333 16.6673H13.75C14.2083 16.6673 14.5833 16.2923 14.5833 15.834V15.0007C14.5833 12.784 10.1417 11.6673 7.91667 11.6673C5.69167 11.6673 1.25 12.784 1.25 15.0007ZM14.5833 8.33398H17.9167C18.375 8.33398 18.75 8.70898 18.75 9.16732C18.75 9.62565 18.375 10.0007 17.9167 10.0007H14.5833C14.125 10.0007 13.75 9.62565 13.75 9.16732C13.75 8.70898 14.125 8.33398 14.5833 8.33398Z",
    fill: "#E41E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludeAudienceIcon);
export default __webpack_public_path__ + "static/media/ExcludeAudienceIcon.c7ff0ca24c627524f52428ac514a9d5a.svg";
export { ForwardRef as ReactComponent };